import { CheckIcon, CopyIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "./button";
import { cn } from "./cn";

/** Copies a value to the clipboard and says so for two seconds. */
export function CopyButton({
  value,
  label,
  className,
}: {
  value: string;
  /** What is copied, when "Copy" alone is not enough. */
  label?: string;
  className?: string;
}) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const name = copied ? t("ui.copied") : (label ?? t("ui.copy"));
  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(timer);
  }, [copied]);
  const copy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
  };
  return (
    <Button
      variant="ghost"
      size="icon-sm"
      aria-label={name}
      title={name}
      className={cn("text-ink-3", className)}
      onClick={() => void copy()}
    >
      {copied ? <CheckIcon aria-hidden className="text-ok" /> : <CopyIcon aria-hidden />}
    </Button>
  );
}
